<div class="w-100 font-16">
    <div class="row ">
        <div class="col-3">
            <i class="mdi mdi-account text-primary mr-1"></i><strong style="font-size:17px">Patient Name:</strong>&nbsp;
            <span *ngIf="appointment" [textContent]="appointment.patientName"></span>
        </div>
        <div class="col-3">
            <i class="mdi  text-primary mr-1"></i><strong style="font-size:17px">UMR No.:</strong>&nbsp;
            <span *ngIf="appointment" [textContent]="appointment.umrNo"></span>
        </div>
    </div>
    <div class="row d-flex font-weight-medium align-items-baseline mt-1">
        <div class="col-3">
            <strong style="font-size:17px">Height:</strong>&nbsp;
            <span *ngIf="measurements && measurements.lengthInCms!=null" [textContent]="measurements.lengthInCms +' cms'"></span>
        </div>
        <div class="col-3">
            <strong style="font-size:17px">Weight:</strong>&nbsp;
            <span *ngIf="measurements && measurements.weightInKgs != null" [textContent]="measurements.weightInKgs +' kg'"> </span>
        </div>
        <div class="col-3">
            <strong style="font-size:17px">HC Temp:</strong>&nbsp;
            <span *ngIf="measurements && measurements.temparature!=null" [textContent]="measurements.temparature +' F'"></span>
        </div>
        <div class="col-3">
            <strong style="font-size:17px">TCB:</strong>&nbsp;
            <span *ngIf="measurements && measurements.tcb!=null" [textContent]="measurements.tcb"></span>
        </div>
    </div>
    <div *ngIf="specialFeature && specialFeature.specialFeature" class="d-flex font-weight-medium w-100">
        <strong class="white-space-nowrap" style="color: darkblue;">Special Features:</strong>
        <span class="break-all" [textContent]="specialFeature.specialFeature"></span>

    </div>
    <div class="col-12" *ngIf="roleId != 63">
        <div id="mandatorySections" class="">
            <div *ngIf="!allergies" class="mb-2">
                <span style="color:red;font-size: large;"><i class="icon-exclamation icon-spin red bigger-125"></i>Allergies section is not reviewed yet</span><br>
            </div>
        </div>
    </div>
</div>
        
  


